var _path, _g, _path2, _path3, _ellipse, _g2, _ellipse2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFooter = function SvgFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 199 52"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "footer_svg__a",
    width: 32,
    height: 22,
    x: 2,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.23 18.662c-.334.138-1.462.63-1.764.8-4.355 2.37-15.084 14.83-15.1 16.861v.138c.207 1.078 18.23 2.37 23.11.878.334-.108 1.478-.57 1.812-.708 3.814-1.615 6.103-5.23 6.103-9.015 0-1.308-.27-2.631-.842-3.908-1.669-3.677-5.404-5.877-9.298-5.877-1.351 0-2.718.262-4.037.815"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#footer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#footer_svg__b)",
    d: "M33.423 17.846H2.366v21h31.057z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "footer_svg__c",
    width: 26,
    height: 37,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.053 3.63A11.6 11.6 0 0 0 1.542 7.4c-.16.385-.716 1.754-.827 2.154C.223 11.23 0 14.139 0 17.446c0 7.246 1.001 16.415 2.146 18.693.127.246.238.384.365.461 2.273 1.739 17.5-13.108 20.79-18.185.429-.661.794-1.415 1.112-2.415.429-1.385.652-2.77.652-4.139 0-4.784-2.67-9.107-7.566-11.03A12.7 12.7 0 0 0 13.573 0h-.635C9.6 0 6.389 1.323 4.068 3.646"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#footer_svg__c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#footer_svg__d)",
    d: "M10.351-11.958-19.511 22.49 14.7 50.278 44.564 15.83z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "footer_svg__f",
    width: 16,
    height: 24,
    x: 2,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.716,
    cy: 11.876,
    fill: "url(#footer_svg__e)",
    rx: 6.716,
    ry: 11.876,
    transform: "matrix(.96199 .27857 -.2908 .95512 6.716 3.388)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#footer_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F84CB",
    d: "M15.216 6.449c-4.193 2.887-8.182 14.419-9.652 19.824l2.322 2.992 11.28-10.285z",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "footer_svg__h",
    width: 19,
    height: 13,
    x: 12,
    y: 22,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.366,
    cy: 9.375,
    fill: "url(#footer_svg__g)",
    rx: 5.366,
    ry: 9.375,
    transform: "matrix(.44892 .8587 -.92043 .4533 27.384 19.44)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#footer_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#287ABF",
    d: "M30.194 25.86c-4.016-.78-13.05 3.248-17.066 5.36l-.502 2.922 12.297.73z",
    opacity: 0.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M50.734 37.662c3.764 0 6.819-2.724 6.819-6.477 0-2.431-1.265-4.277-3.178-5.277 1.419-1.031 2.298-2.662 2.298-4.631 0-3.616-2.977-6.277-6.649-6.277H41v22.661zm-6-13.216v-5.97h5.29c1.651 0 2.916 1.293 2.916 2.986 0 1.692-1.265 2.984-2.916 2.984zm6 3.385c1.759 0 3.085 1.384 3.085 3.169v.015c0 1.785-1.326 3.17-3.085 3.17h-6V27.83z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "M68.43 24.97v-3.785c-2.037 0-4.027.815-4.999 3.015v-2.723H59.93V37.66h3.502v-8.153c0-3.631 2.7-4.708 4.998-4.539"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M86.325 37.661h-3.502v-2.338c-1.234 1.723-3.147 2.753-5.677 2.753-4.412 0-8.084-3.723-8.084-8.523s3.672-8.523 8.084-8.523c2.53 0 4.443 1.031 5.677 2.723v-2.292h3.502zm-3.502-8.092c0-3.016-2.206-5.185-5.137-5.185s-5.137 2.17-5.137 5.185 2.206 5.184 5.137 5.184 5.137-2.169 5.137-5.184",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "m98.272 37.662 6.325-16.184h-3.826l-4.52 12.307-4.535-12.307h-3.841l6.34 16.184z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M104.602 29.569c0-4.83 3.825-8.523 8.577-8.523s8.577 3.692 8.577 8.523-3.795 8.523-8.577 8.523c-4.783 0-8.577-3.723-8.577-8.523m13.636 0c0-2.954-2.206-5.123-5.059-5.123s-5.06 2.17-5.06 5.123 2.206 5.123 5.06 5.123 5.059-2.17 5.059-5.123",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "M136.721 18.57h6.386V15h-16.552v3.57h6.432V37.66h3.734z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M139.93 29.569c0-4.83 3.825-8.523 8.577-8.523s8.577 3.692 8.577 8.523-3.795 8.523-8.577 8.523-8.577-3.723-8.577-8.523m13.637 0c0-2.954-2.206-5.123-5.06-5.123s-5.06 2.17-5.06 5.123 2.206 5.123 5.06 5.123 5.06-2.17 5.06-5.123",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "M173.927 37.662v-16.2h-3.502v8.677c0 3.308-1.913 4.661-4.119 4.661s-3.64-1.292-3.64-3.753v-9.585h-3.502V31.4c0 4.216 2.592 6.677 6.232 6.677 2.206 0 3.949-.8 5.029-2.492v2.077zM185.219 21.185v3.784c-2.299-.169-4.998.908-4.998 4.539v8.153h-3.502V21.477h3.502V24.2c.971-2.2 2.961-3.015 4.998-3.015M192.071 38.092c3.502 0 6.325-1.738 6.325-4.984h.015c0-3.515-3.012-4.35-5.498-5.04-1.746-.483-3.233-.895-3.233-2.114 0-1.17 1.049-1.723 2.376-1.723s2.468.584 3.054 1.846l2.946-1.646c-1.126-2.139-3.332-3.37-6-3.37-3.302 0-5.94 1.908-5.94 4.954 0 3.404 3.006 4.254 5.491 4.956 1.75.495 3.241.917 3.241 2.106 0 1.292-1.203 1.815-2.762 1.815-1.789 0-3.085-.877-3.609-2.338l-3.024 1.754c1.034 2.323 3.379 3.784 6.618 3.784"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "footer_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 11.8758 -6.71629 0 6.716 11.876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "footer_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 9.37488 -5.36619 0 5.366 9.375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "footer_svg__b",
    x1: 3.662,
    x2: 34.703,
    y1: 29.097,
    y2: 29.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2A97D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2577BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "footer_svg__d",
    x1: -2.956,
    x2: 20.887,
    y1: 34.816,
    y2: 5.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#41C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })))));
};
export default SvgFooter;